// Vendors
import { isDesktopDevice, isMobileDevice, isTabletDevice } from '@openbank/cf-ui-framework';
import { DevicesBreakpointsEnumeration } from '@gruposantander/opbpay-ui-core-models';
// Enumerations
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
// Types
import {
  CheckoutHandlersUsernameUtilsType,
  CheckoutHandlersUtilsType,
} from './types/checkout.handlers.utils.type';

const customerAuthDataHasBeenLoaded = (
  informationFlags: AppInformationNeedEnumeration[]
): boolean =>
  informationFlags.includes(AppInformationNeedEnumeration.AUTHORIZATION_DATA) &&
  !informationFlags.includes(AppInformationNeedEnumeration.CHECKOUT_DATA);

const getClientDevice = (): string => {
  switch (true) {
    case isMobileDevice():
      return DevicesBreakpointsEnumeration.MOBILE;
    case isTabletDevice():
      return DevicesBreakpointsEnumeration.TABLET;
    case isDesktopDevice():
    default:
      return DevicesBreakpointsEnumeration.DESKTOP;
  }
};

const hasCustomerName = ({ firstName, lastName }: CheckoutHandlersUsernameUtilsType): boolean =>
  Boolean(firstName && lastName);

const noTMXLoadedAndNoRedirectDataSaved = ({
  tmxCallDone,
  retries,
}: CheckoutHandlersUtilsType): boolean => !tmxCallDone && retries < 4;

const noTMXLoadedAndNoMoreRetriesAllowed = ({
  tmxCallDone,
  retries,
}: CheckoutHandlersUtilsType): boolean => !tmxCallDone && retries > 3;

export {
  customerAuthDataHasBeenLoaded,
  getClientDevice,
  hasCustomerName,
  noTMXLoadedAndNoRedirectDataSaved,
  noTMXLoadedAndNoMoreRetriesAllowed,
};
